// extracted by mini-css-extract-plugin
export default {"body":"testimonial_body__RqlRc","quote":"testimonial_quote__Ybr6g","container":"testimonial_container__OitZb","details":"testimonial_details__WVqEJ"};